var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent, createRef } from 'react';
import { bool, func, array } from 'prop-types';
import Slider from 'searchband-frontend-commons/components/slider/slider';
import Tab from './tab';
import * as funcUtil from 'searchband-frontend-commons/util/func';
import { setCss } from 'searchband-frontend-commons/util/css';
import * as CLS from './cls';

var ACTIVE_SELECTOR = '.' + CLS.tab() + '_isActive';

var TabsList = function (_PureComponent) {
    _inherits(TabsList, _PureComponent);

    function TabsList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TabsList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabsList.__proto__ || Object.getPrototypeOf(TabsList)).call.apply(_ref, [this].concat(args))), _this), _this.domRef = createRef(), _this.targetRef = createRef(), _this.sliderRef = createRef(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TabsList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.moveTarget();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            if (this.props.activeTab !== oldProps.activeTab) {
                this.moveTarget();
            }
        }
    }, {
        key: 'moveTarget',
        value: function moveTarget() {
            var activeNode = this.domRef.current.querySelector(ACTIVE_SELECTOR);

            if (!activeNode) {
                return;
            }

            var containerRect = this.targetRef.current.parentElement.getBoundingClientRect();
            var rect = activeNode.getBoundingClientRect();
            var x = rect.left - containerRect.left;
            var y = rect.top - containerRect.top;

            setCss(this.targetRef.current, 'width: ' + activeNode.clientWidth + 'px', 'transform: translate(' + x + 'px, ' + y + 'px)', 'background: ' + this.props.activeTabBgColor);
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var hasDelimiter = props.hasDelimiter,
                activeTab = props.activeTab;

            var style = {
                borderBottomColor: props.delimiterColor,
                color: props.inactiveTabColor
            };

            return React.createElement(
                'div',
                {
                    className: CLS.tabsList({
                        hasDelimiter: hasDelimiter
                    })(),
                    style: style,
                    ref: this.domRef
                },
                React.createElement(
                    Slider,
                    {
                        ref: this.sliderRef
                    },
                    React.createElement('div', {
                        className: CLS.tabTarget,
                        ref: this.targetRef
                    }),
                    props.items.map(function (tab, index) {
                        return React.createElement(Tab, {
                            title: tab.title,
                            action: tab.action,
                            index: index,
                            key: index,
                            onClick: props.onTabClick,
                            isActive: index === activeTab,
                            activeTabColor: props.activeTabColor
                        });
                    })
                )
            );
        }
    }]);

    return TabsList;
}(PureComponent);

TabsList.defaultProps = {
    onTabClick: funcUtil.empty,
    items: [],
    hasDelimiter: false
};
TabsList.propTypes = {
    hasDelimiter: bool,
    items: array.isRequired,
    onTabClick: func.isRequired
};
export default TabsList;